var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMarkerRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9154 25.725C24.9747 25.725 28.2654 22.4343 28.2654 18.375C28.2654 14.3157 24.9747 11.025 20.9154 11.025C16.8561 11.025 13.5654 14.3157 13.5654 18.375C13.5654 22.4343 16.8561 25.725 20.9154 25.725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4067 34.4891C28.5726 36.4184 26.6129 38.176 24.6525 39.7316C23.9653 40.2769 23.3259 40.7589 22.75 41.1734C22.399 41.426 22.1433 41.6025 21.9985 41.6987C21.3938 42.1004 20.6062 42.1004 20.0015 41.6987C19.8567 41.6025 19.601 41.426 19.25 41.1734C18.6741 40.7589 18.0347 40.2769 17.3475 39.7316C15.3871 38.176 13.4274 36.4184 11.5933 34.4891C6.24432 28.8626 3 24.9853 3 18.9375C3 9.03089 11.0589 1 21 1C30.9411 1 39 9.03089 39 18.9375C39 24.9853 35.7557 28.8626 30.4067 34.4891Z",
    fill: "#E53935"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0292 29.7354C24.1183 28.8682 25.207 27.8883 26.226 26.8127C29.1976 23.676 31 20.3716 31 17C31 11.4772 26.5228 7 21 7C15.4772 7 11 11.4772 11 17C11 20.3716 12.8024 23.676 15.774 26.8127C16.793 27.8883 17.8817 28.8682 18.9708 29.7354C19.3526 30.0394 19.7078 30.3081 20.0278 30.5392C20.2228 30.68 20.3649 30.7784 20.4453 30.8321C20.7812 31.056 21.2188 31.056 21.5547 30.8321C21.6351 30.7784 21.7772 30.68 21.9722 30.5392C22.2922 30.3081 22.6474 30.0394 23.0292 29.7354ZM24.7741 25.4372C23.8243 26.4398 22.8037 27.3584 21.7834 28.1708C21.5049 28.3926 21.2424 28.5936 21.0001 28.7726C20.7577 28.5936 20.4952 28.3926 20.2167 28.1708C19.1964 27.3584 18.1758 26.4398 17.226 25.4372C14.5727 22.6365 13.0001 19.7534 13.0001 17C13.0001 12.5817 16.5818 8.99999 21.0001 8.99999C25.4183 8.99999 29.0001 12.5817 29.0001 17C29.0001 19.7534 27.4275 22.6365 24.7741 25.4372ZM21 21C18.7909 21 17 19.2091 17 17C17 14.7909 18.7909 13 21 13C23.2091 13 25 14.7909 25 17C25 19.2091 23.2091 21 21 21ZM23.0001 17C23.0001 18.1046 22.1046 19 21.0001 19C19.8955 19 19.0001 18.1046 19.0001 17C19.0001 15.8954 19.8955 15 21.0001 15C22.1046 15 23.0001 15.8954 23.0001 17Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerRed);
export default __webpack_public_path__ + "static/media/markerRed.0f8a23544940800169aad67d52674d86.svg";
export { ForwardRef as ReactComponent };